import axiosClient from './AxiosClient';
import { TenpoResponseDto, TenpoControllerFindTenpoRequest } from './generated/openapi';

const TenpoService = {
  get(params: TenpoControllerFindTenpoRequest): Promise<TenpoResponseDto> {
    return axiosClient
      .get<TenpoResponseDto>(`/tenpo/${params.tenpoCode}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to fetch data: ${error}`);
      });
  },
};

export default TenpoService;
